'use client';

import React from 'react';

import { Body } from '@depop/web-thrift-ui/Typography';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { SecondaryPriceLine } from '@/components/SecondaryPriceLine';
import { type OfferProductPrice } from '@/modules/offers/buyers/types';
import { getHeadlineDescriptionKey } from '@/modules/price/helpers/displayPriceRules';

type Props = {
  currencySymbol: string;
  productPrice: OfferProductPrice;
  imageHref?: string;
  sizeName?: string;
};

export function OfferModalProductSummary({
  currencySymbol,
  imageHref,
  productPrice,
  sizeName,
}: Props) {
  const tOffers = useTranslations('offers');
  const { displayPrice } = productPrice;
  const captionKey = getHeadlineDescriptionKey(
    displayPrice?.headline_price_components
  );

  return (
    <div className={styles.wrapper}>
      <img
        className={styles.image}
        src={imageHref}
        height={88}
        width={88}
        alt=""
      />
      <div>
        {sizeName && (
          <Body variant="sm-regular" className={styles.sizeName}>
            {sizeName}
          </Body>
        )}
        <Body variant="sm-bold">
          {tOffers('CurrentItemPrice', {
            price: currencySymbol + productPrice.baseCurrentPrice,
          })}
        </Body>
        {displayPrice && captionKey && (
          <Body variant="sm-regular" className={styles.includingFeesText}>
            {currencySymbol + displayPrice.headline_price.amount}{' '}
            {tOffers(captionKey)}
          </Body>
        )}
        {displayPrice?.secondary_price && (
          <SecondaryPriceLine secondaryPrice={displayPrice.secondary_price} />
        )}
      </div>
    </div>
  );
}
